const Swal = window.Swal = require('sweetalert2');
const Dropzone = window.Dropzone = require("dropzone");
const jsYearCalendar = window.jsYearCalendar = require("js-year-calendar");
const Chart  = window.Chart = require('chart.js/auto');
const Sortable = window.Sortable =  require('sortablejs').Sortable;
const Inputmask = require('inputmask');
import { Calendar } from '@fullcalendar/core';
const FullCalendar = window.FullCalendar = require('fullcalendar');
const allLocales = window.allLocales = require('@fullcalendar/core/locales-all');
const DataTable = window.DataTable  = $.DataTable = require( 'datatables.net-bs5' );

import AirDatepicker from 'air-datepicker';
import 'air-datepicker/air-datepicker.css';

// Importar los locales necesarios
import localeEs from 'air-datepicker/locale/es';
import localeCa from 'air-datepicker/locale/ca';
import localeEn from 'air-datepicker/locale/en';
import localeFr from 'air-datepicker/locale/fr';
import localeIt from 'air-datepicker/locale/it';
import localeDe from 'air-datepicker/locale/de';
import localePt from 'air-datepicker/locale/pt';
import localeRu from 'air-datepicker/locale/ru';
import localeSv from 'air-datepicker/locale/sv';

window.AirDatepicker = AirDatepicker;

// Crear un diccionario de idiomas global
window.datepickerLocales = {
    es: localeEs,
    en: localeEn,
    fr: localeFr,
    ca: localeCa,
    it: localeIt,
    de: localeDe,
    pt: localePt,
    ru: localeRu,
    sv: localeSv,
};


import moment from 'moment';
import 'moment/min/locales';
window.moment = moment;

import { Timeline } from 'vis-timeline';
import { DataSet } from 'vis-data';

import 'vis-timeline/styles/vis-timeline-graph2d.css';
window.vis = {
    Timeline: Timeline,
    DataSet: DataSet
};

/*
//import Alpine from 'alpinejs';
import { Livewire, Alpine } from 'livewire/alpine';
import intersect from '@alpinejs/intersect';
//window.Alpine = Alpine;
Alpine.plugin(intersect);
Livewire.start();
*/
